<div class="edit-prompt-container">
  <div class="header-container">
    <div class="header-title">
      <ion-label>{{promptType}}</ion-label>
    </div>
    <div class="header-close"> 
      <div class="btns" *ngIf="editable">
      <app-submit buttonText="Cancel" buttonType="rectCancel" (click)="cancel()"
       ></app-submit>

      <app-submit buttonText="Submit" buttonType="rectSave" (click)="submit()"
       ></app-submit>
    </div>

    <div class="close" (click)="close()">
      <ion-img src="assets/images/close.svg"></ion-img>
    </div>
  </div>
  </div>
  <div class="err-msg" *ngIf="invalidPrompt">
    <ion-label>{{errMsg}}</ion-label>
  </div>
  <div class="content-container" *ngIf="promptType!=='LLM Response' && promptType!=='Similarity Results'" >
      <div [attr.contenteditable]="editable" class="editable-text" (blur)="onInput($event)">
        {{ text }}
      </div>
  </div>
  <div class="candidates-container" *ngIf="promptType =='Similarity Results'">
    <div *ngFor="let item of text" class="candidate-row">
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">ID:</ion-col>
        <ion-col class="detail-value">{{item.candidate.id}}</ion-col>
      </ion-row>
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">Question:</ion-col>
        <ion-col class="detail-value">{{item.candidate.question}}</ion-col>
      </ion-row>
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">SQL:</ion-col>
        <ion-col class="detail-value sql-code">{{item.candidate.sql}}</ion-col>
      </ion-row>
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">Distance:</ion-col>
        <ion-col class="detail-value">{{item.distance | number:'1.5-5'}}</ion-col>
      </ion-row>
    </div>
  </div>
  <div class="candidates-container" *ngIf="promptType =='LLM Response'">
    <div class="candidate-row">
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">Matched:</ion-col>
        <ion-col class="detail-value">{{text.matched}}</ion-col>
      </ion-row>
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">Original Sql:</ion-col>
        <ion-col class="detail-value">{{text.original_sql}}</ion-col>
      </ion-row>
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">Final Matched Sql:</ion-col>
        <ion-col class="detail-value sql-code">{{text.final_matched_sql}}</ion-col>
      </ion-row>
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">Sql Modified:</ion-col>
        <ion-col class="detail-value">{{text.sql_modified}}</ion-col>
      </ion-row>
      <ion-row class="candidate-detail">
        <ion-col class="detail-label" size="3">Confidence:</ion-col>
        <ion-col class="detail-value">{{text.confidence}}</ion-col>
      </ion-row>
    </div>
  </div>
</div>
